import React from 'react';
import { Switch as AntdSwitch } from 'antd';
import { SwitchProps } from 'antd/lib/switch';

import './switch.scss';

interface Props extends SwitchProps {}

const Switch: React.FunctionComponent<Props> = (props: Props) => {
	const { className, ...restOfProps } = props;

	return <AntdSwitch className={`bringg-switch ${className || ''}`} {...restOfProps} />;
};

export { Switch };
